import { createStyles } from "@material-ui/core";
import { colors } from "theme";

const styles = createStyles({
  subListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  subListItemParentSelected: {
    backgroundColor: "#00000024",
  },
  subListItemText: {
    color: colors.gray[800],
    fontFamily: "Inter, sans-serif",
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 400,
    marginLeft: 30,
  },
  subListItemTextSelected: {
    color: colors.gray[800],
    fontFamily: "Inter, sans-serif",
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 400,
    marginLeft: 30,
  },
  subListItemIcon: {
    paddingLeft: 5.5,
  },
  navlink: () => ({
    textDecoration: "none",
    outline: "none",
    "& > .Mui-selected": {
      cursor: "default",
    },
  }),
  navHidden: {
    visibility: "hidden",
  },
  navItem: {
    borderRadius: 8,
    "&.Mui-selected": {
      backgroundColor: colors.white,
    },
    "&.Mui-selected:hover": {
      backgroundColor: colors.white,
    },
  },
  navItemText: {
    color: colors.gray[800],
    fontFamily: "Inter, sans-serif",
    fontSize: 16,
    fontStyle: "normal",
    fontWeight: 400,
  },
  navIcon: {
    minWidth: 32,
  },
  subMenuSelector: {
    background: colors.black,
    width: 1,
    height: 28,
    marginLeft: 20,
    position: "absolute",
  },
  subMenuSelectedIndicator: {
    background: colors.white,
  },
});

export default styles;
